export type ScenarioPreset = 'bothStagnate' | 'stocksWin' | 'balanced' | 'realEstateWins' | 'bothBoom';

export interface ScenarioConfig {
  propertyAppreciation: number;
  stockReturns: number;
  rentGrowth: number;
}

export const scenarioPresets: Record<ScenarioPreset, ScenarioConfig> = {
  bothStagnate: {
    propertyAppreciation: 2.0,
    stockReturns: 4.0,
    rentGrowth: 0.0
  },
  stocksWin: {
    propertyAppreciation: 2.3,
    stockReturns: 8.5,
    rentGrowth: 0.5
  },
  balanced: {
    propertyAppreciation: 3.5,
    stockReturns: 7.5,
    rentGrowth: 1.0
  },
  realEstateWins: {
    propertyAppreciation: 4.5,
    stockReturns: 6.5,
    rentGrowth: 1.5
  },
  bothBoom: {
    propertyAppreciation: 8.0,
    stockReturns: 12.5,
    rentGrowth: 2.0
  },
};

export const scenarioLabels: Record<ScenarioPreset, { full: string; short: string }> = {
  bothStagnate: { full: 'Both Stagnate', short: 'Stagnate' },
  stocksWin: { full: 'Stocks Outperform', short: 'Stocks' },
  balanced: { full: 'Balanced', short: 'Balanced' },
  realEstateWins: { full: 'RE Outperforms', short: 'RE' },
  bothBoom: { full: 'Both Boom', short: 'Boom' },
};
